export default "__VITE_ASSET__Da8uGCHK__"